// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"./colors.css\"","typography":"'./typography.css'","netsurfDarkBlue":"#151F41"};